// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3OOML","content":"ManualTimeModal_content__13hVi"};